import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n';
import LandingPage from './pages/LandingPage';
import DemoPage from './pages/DemoPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyOtpPage from './pages/VerifyOtpPage';
import DashboardHomeRedirect from './pages/DashboardHomeRedirect';
import RoleDashboardPage from './pages/RoleDashboardPage';
import PrivateRoute from './compnents/PrivateRoute';
import Datasets from './pages/Datasets';
import Settings from './pages/Settings';
import Subscription from './pages/Subscription';
import NotFound from './compnents/NotFound';
import ManageCustomers from './pages/ManageCustomers';
import Domain from './pages/Domain';
import ReportsExports from './pages/ReportsExports';
import ResetPassword from './pages/ResetPassword';
import PlatformPlansPage from './pages/PlatformPlansPage';
import DeveloperPortal from './pages/DeveloperPortal';
import AuditCompliance from './pages/AuditCompliance';
import ConnectedPilot from './pages/ConnectedPilot';

function App() {
  return (
    // The provider sits inside the router so a route can carry ?lang= and so
    // /demo can default to Spanish; see src/i18n/index.js.
    <I18nProvider>
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/" element={<LandingPage />} />
      <Route path="/platform" element={<PlatformPlansPage />} />
      {/* Public: no login, no email, synthetic data only. */}
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-otp" element={<VerifyOtpPage />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <DashboardHomeRedirect />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/demo"
        element={
          <PrivateRoute>
            <RoleDashboardPage roleKey="demo" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/admin"
        element={
          <PrivateRoute>
            <RoleDashboardPage roleKey="admin" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/rm"
        element={
          <PrivateRoute>
            <RoleDashboardPage roleKey="rm" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/head"
        element={
          <PrivateRoute allowedSubscriptions={['business']}>
            <RoleDashboardPage roleKey="head" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/portfolio"
        element={
          <PrivateRoute allowedSubscriptions={['business']}>
            <RoleDashboardPage roleKey="portfolio" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/compliance"
        element={
          <PrivateRoute allowedSubscriptions={['business']}>
            <RoleDashboardPage roleKey="compliance" />
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard/view-only"
        element={
          <PrivateRoute allowedSubscriptions={['business']}>
            <RoleDashboardPage roleKey="view_only" />
          </PrivateRoute>
        }
      />
      <Route
        path="/datasets"
        element={
          <PrivateRoute>
            <Datasets />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <Settings />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscription"
        element={
          <PrivateRoute>
            <Subscription />
          </PrivateRoute>
        }
      />
      <Route
        path="/docs"
        element={
          <PrivateRoute allowedRoles={['admin']} allowedSubscriptions={['business']}>
            <DeveloperPortal />
          </PrivateRoute>
        }
      />
      <Route
        path="/domain"
        element={
          <PrivateRoute allowedRoles={['admin']} allowedSubscriptions={['business']}>
            <Domain />
          </PrivateRoute>
        }
      />
      <Route
        path="/reportsExports"
        element={
          <PrivateRoute allowedRoles={['admin', 'rm']} allowedSubscriptions={['solo', 'pro', 'business']}>
            <ReportsExports />
          </PrivateRoute>
        }
      />
      <Route
        path="/auditsCompliance"
        element={
          <PrivateRoute allowedRoles={['admin', 'compliance']} allowedSubscriptions={['business']}>
            <AuditCompliance />
          </PrivateRoute>
        }
      />
      <Route
        path='/settings/manageCustomers'
        element={
          <PrivateRoute allowedRoles={['admin']} allowedSubscriptions={['pro', 'business']}>
            {/* Assigning clients to advisers is a Team capability. */}
            <ManageCustomers />
          </PrivateRoute>
        }
      />
      <Route
        path="/connected"
        element={
          <PrivateRoute allowedRoles={['admin']} allowedSubscriptions={['business']}>
            <ConnectedPilot />
          </PrivateRoute>
        }
      />
    </Routes>
    </I18nProvider>
  );
}

export default App;
